export const exampleCSS = `display: block;
font-size: 16px;
background: #1e2f5d;
color: #a4cff4;
font-family: "Inter", sans-serif;
font-weight: bold;`;

export const exampleJS = `{
  display: "block",
  fontSize: 16,
  background: "#1e2f5d",
  color: "#a4cff4",
  fontFamily: "'Inter', sans-serif",
  fontWeight: "bold"
}`;

export const exampleJSX = `display="block"
fontSize={16}
background="#1e2f5d"
color="#a4cff4"
fontFamily="'Inter', sans-serif"
fontWeight="bold"`;
